export const GEO_DATA = {
  COUNTRIES: 'countries',
  DISTRICTS: 'districts',
  DIVISIONS: 'divisions',
};
